import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button, Dialog, DialogActions, DialogContent,
  FormLabel,
  TextField,
  Typography,
} from '@material-ui/core';
import { IsEmpty } from '../../../common/checks';

const PreCreateModal = ({ isSpecial, isExclusive, onClose, onComplete }) => {
  const [title, setTitle] = useState('');

  const cancelClicked = () => {
    onClose();
  };

  const addClicked = () => {
    onComplete({ title });
  };

  return (
    <>
      <div>
        <Dialog
          fullWidth
          maxWidth="sm"
          open
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <div className="mt-3">
              <Typography variant="h5">{`Create ${isSpecial ? 'Special' : isExclusive ? 'Exclusive' : ''} Highlight`}</Typography>
              <FormLabel component="legend" className="mt-3">Enter title of highlight (can be modified later)</FormLabel>

              <TextField
                id="titleTextField"
                className="mt-2"
                autoFocus
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                variant="outlined"
                multiline
                size="small"
                fullWidth
              />
              {
                IsEmpty(title) && (
                  <label htmlFor="titleTextField" className="mt-1" style={{ color: 'red', fontStyle: 'italic' }}>*Title is required</label>
                )
              }
            </div>
          </DialogContent>
          <DialogActions>
            <Button className="px-5" onClick={() => cancelClicked()}>
              Cancel
            </Button>
            <Button
              className="mx-3 px-5"
              variant="contained"
              color="primary"
              disabled={IsEmpty(title)}
              onClick={() => addClicked()}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

PreCreateModal.propTypes = {
  isSpecial:   PropTypes.bool,
  isExclusive: PropTypes.bool,
  onComplete:  PropTypes.func.isRequired,
  onClose:     PropTypes.func.isRequired,
};

PreCreateModal.defaultProps = {
  isSpecial:   false,
  isExclusive: false,
};

export default connect(null, {})(PreCreateModal);
